import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IOrderModel } from 'src/app/appModels/IOrderModel';
import { OrderService } from './order.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionResolver {
  selectedOrderType = new BehaviorSubject(null);
  searchModel = new BehaviorSubject(null);
  selectedOrderPaid = new BehaviorSubject('saved');

  orderList = new BehaviorSubject<IOrderModel[]|null>(null);
  private isRefreshing = false;

  todayDate!:any;
  dayRange!:any;

  constructor(private orderService: OrderService) { }

  getOrderById(id:number) {
    return this.orderList?.value?.filter((e) => e.id === id);
  }

  /**
   * refresh orders
   */
  public refreshOrders() {
    this.getOrdersByApi();
  }

  /**
   * get orders by api
   */
  private getOrdersByApi() {
    if (this.isRefreshing) {
      return;
    }
    this.isRefreshing = true;

    this.todayDate = new Date();
    this.dayRange = {
      from: new Date().setHours(0, 0, 0, 0),
      to: new Date().getTime(),
    };
    this.orderService
      .getOrdersByDays(this.dayRange.from, this.dayRange.to)
      .subscribe({
        next: (res) => {
          this.setOrders(res);
        },
        error: () => {
          this.isRefreshing = false;
        },
        complete: () => {
          this.isRefreshing = false;
        }
      });
  }

  /**
   * set orders
   *
   * @param orders
   */
  private setOrders(orders:any) {
    this.orderList.next(orders);
  }

  


  clearOrderCache(){
    this.orderList.next(null);
  }
}
